import { Map, List, fromJS } from 'immutable'
import get from 'lodash/get'

import { selectActivityNode } from './selectors'
import * as actions from './actions'
import { LIMIT_FEED } from './'

export const initialState = Map()

export default function (state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case actions.COMMUNITY_SET_FEED: {
      const { data, id } = payload
      const errors = get(data, 'errors')
      if (errors) {
        return state.set('errors', fromJS(errors))
      }
      return state.setIn(['feeds', id], fromJS(data))
    }
    case actions.COMMUNITY_SET_ACTIVITY: {
      const { data } = payload
      const errors = get(data, 'errors')
      if (errors) {
        return state.set('errors', fromJS(errors))
      }
      const activity = fromJS(data)
      const activityId = activity.getIn(['data', 'uuid'], '')
      return state.setIn(['activity', activityId], activity)
    }
    case actions.COMMUNITY_SET_ACTIVITIES: {
      const { data, feedId } = payload
      const dataMap = fromJS(data)
      const newChildren = dataMap.getIn(['data', 'relationships', 'children'], List())
      const endHasBeenReached = !!state.getIn(['feeds', feedId, 'data', 'attributes', 'end'], '')
      const newState = state.setIn(['feeds', feedId], dataMap)
      // indicate if there are no more top level activities to be fetched
      if (newChildren.size < LIMIT_FEED || endHasBeenReached) {
        const veryLastUuid = newChildren.getIn([newChildren.size - 1, 'uuid'], '')
        return newState.setIn(['feeds', feedId, 'data', 'attributes', 'end'], veryLastUuid)
      }
      return newState
    }
    case actions.COMMUNITY_MERGE_ACTIVITIES: {
      const { data, feedId, limit } = payload
      const dataMap = fromJS(data)
      const oldChildren = state.getIn(['feeds', feedId, 'data', 'relationships', 'children'], List())
      const newChildren = dataMap.getIn(['data', 'relationships', 'children'], List())
      const mergedChildren = oldChildren.concat(newChildren).toSet().toList()
      const oldIncluded = state.getIn(['feeds', feedId, 'included'], List())
      const newIncluded = dataMap.getIn(['included'], List())
      const mergedIncluded = oldIncluded.concat(newIncluded).toSet().toList()
      const orderedChildren = mergedChildren.sortBy((c) => {
        const node = selectActivityNode(c, mergedIncluded)
        return node.get('createdAt')
      })
      // indicate if there are no more top level activities to be fetched
      const veryLastUuid = newChildren.size < limit ? orderedChildren.getIn([orderedChildren.size - 1, 'uuid'], null) : null
      return state.setIn(['feeds', feedId, 'data', 'relationships', 'children'], orderedChildren.reverse())
        .setIn(['feeds', feedId, 'included'], mergedIncluded)
        .setIn(['feeds', feedId, 'data', 'attributes', 'end'], veryLastUuid)
    }
    case actions.COMMUNITY_DELETE_DRAFT: {
      const { draftId } = payload
      const drafts = state.get('drafts', Map())
      return state.set('drafts', drafts.delete(draftId))
    }
    case actions.COMMUNITY_SET_DRAFT: {
      const { draftId, draft } = payload
      return state.setIn(['drafts', draftId], draft)
    }
    case actions.COMMUNITY_UNMOUNT_PAGE: {
      return Map()
    }
    default:
      return state
  }
}
